module.exports = __webpack_public_path__ + "img/bg-financial-tips-desktop.d02abeee.jpg";